import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { Beneficiary, MoniepointBeneficiaryModel } from '../../../../shared/models/transfer.model';
import { ModalOptionsConfig, ModalService } from '../../nz-modal-service/modal.service';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { BeneficiaryModalComponent } from './partials/beneficiary-modal/beneficiary-modal.component';
import { StringHelper } from '../../../../core/helpers/strings.helper';

@Component({
	selector: 'app-moniepoint-beneficiary',
	templateUrl: './moniepoint-beneficiary.component.html',
	styleUrls: ['./moniepoint-beneficiary.component.scss']
})
export class MoniepointBeneficiaryComponent implements OnInit {
	@Input() beneficiaries: Beneficiary[];
	@Output() selectedBeneficiary = new EventEmitter();
	@Output() selectedMoreBeneficiary = new EventEmitter();
	@Output() manageBeneficiaries = new EventEmitter();
	@Input() searchParams = '';
	@Input() newTransfer: boolean = false;
	@Input() cantManage: boolean = false;
	@Input() beneficiaryType: BeneficiaryType;
	BILL_PAYMENT_TYPE: BeneficiaryType = 'bill-payment';
	AIRTIME_TYPE: BeneficiaryType = 'airtime';
	TRANSFER_TYPE: BeneficiaryType = 'transfer';
	moniepointBeneficiaries: MoniepointBeneficiaryModel[] = [];
	@Input() totalMoniepointBeneficiaries: MoniepointBeneficiaryModel[] = [];
	@Input() customerSearch: string;
	runningModal: NzModalRef;
	isMobile: boolean = false;
	breakPoint = 900;

	constructor(private modal: ModalService) {
	}

	ngOnInit(): void {
		if (!this.beneficiaryType) {
			this.beneficiaryType = 'bill-payment';
		}
		// this.moniepointBeneficiaries = this.getMockBeneficiary();
		this.preFillBeneficiaries();
		this.onResize(window.innerWidth);
	}

	preFillBeneficiaries() {
		this.moniepointBeneficiaries = [];
		this.totalMoniepointBeneficiaries.forEach((e, index) => {
			if (index < 4) {
				this.moniepointBeneficiaries.push(e);
			}
		});
	}

	getBeneficiaryContainerColor(index) {

		switch (index) {
			case 1:
				return 'color_I';
			case 2:
				return 'color_II';
			case 3:
				return 'color_III';
			default:
				return '';
		}

	}

	getBeneficiaryBoxColor(index) {
		switch (index) {
			case 1:
				return 'color_I_box';
			case 2:
				return 'color_II_box';
			case 3:
				return 'color_III_box';
			default:
				return 'beneficiary-box-bg';
		}
	}

	getMockBeneficiary() {
		const beneficiary: MoniepointBeneficiaryModel = {
			customerIdName: 'MTN',
			customerIdValue: '08035826579',
			beneficiaryName: 'Adekunle Gold',
			id: 1
		};
		const beneficiaryI: MoniepointBeneficiaryModel = {
			customerIdName: 'AIRTIME',
			customerIdValue: '08035826579',
			beneficiaryName: 'Samuel Onome Ojumah-Ineye',
			id: 2
		};
		const beneficiaryII: MoniepointBeneficiaryModel = {
			customerIdName: 'GLO',
			customerIdValue: '08035826579',
			beneficiaryName: 'Ade Perlin',
			id: 3
		};

		const arr: MoniepointBeneficiaryModel[] = [];
		arr.push(beneficiary);
		arr.push(beneficiaryI);
		arr.push(beneficiaryII);

		return arr;
	}

	openMore() {
		if (this.beneficiaryType == this.TRANSFER_TYPE && this.isMobile) {
			let obj = {
				cantManage: this.cantManage,
				beneficiaries: this.totalMoniepointBeneficiaries,
				refinedbeneficiaries: this.beneficiaries,
			}
			this.selectedMoreBeneficiary.emit(obj);
		} else {
			this.launchModal(BeneficiaryModalComponent, this.totalMoniepointBeneficiaries);
		}
	}

	launchModal(component: any, data?) {
		const config = this.createFilterConfig(data);
		this.runningModal = this.modal.createModal(
			component,
			config
		);
	}

	createFilterConfig(data?) {
		const config = new ModalOptionsConfig();
		if (data) {
			config.nzComponentParams.data = {
				beneficiaries: data,
				newTransferView: this.newTransfer
			}
		}
		config.nzMaskClosable = true;
		config.nzComponentParams.callback = (result) => {
			this.onActionComplete(result);
		};
		return config;
	}

	onActionComplete(result) {
		if (result?.action && result.action == 'manage_beneficiaries') {
			let obj = {
				beneficiaries: this.totalMoniepointBeneficiaries,
				refinedbeneficiaries: this.beneficiaries
			}
			this.manageBeneficiaries.emit(obj);
		} else {
			this.selectBeneficiary(result);
		}

		this.runningModal.destroy();
	}


	selectBeneficiary(beneficiary) {
		let selectedBeneficiary: Beneficiary = null;
		this.beneficiaries.forEach(e => {
			if (e.id === beneficiary?.id) {
				selectedBeneficiary = e;
			}
		});
		this.selectedBeneficiary.emit(selectedBeneficiary);
	}

	getInitials(beneficiaryName: string) {
		return StringHelper.getInitials(beneficiaryName);
	}

	@HostListener('window:resize', ['$event'])
	onResize(_event): void {
		this.setMobile(window.innerWidth);
	}

	setMobile(browserWidth: number) {
		this.isMobile = browserWidth <= this.breakPoint;
	}
}

export type BeneficiaryType = | 'bill-payment' | 'transfer' | 'airtime';
